import posthog from './posthogClient';

/**
 * Utility function to manually track PostHog events
 * @param {string} eventName - Name of the event to track
 * @param {object} properties - Additional properties to send with the event
 */
export const trackPostHogEvent = (eventName, properties = {}) => {
    if (process.env.REACT_APP_NODE_ENV === 'Dev') return; // No posthog tracking in non-production environments
    posthog.capture(eventName, {
            ...properties,
            $current_url: window.location.href,
            $pathname: window.location.pathname
        });
};

/**
 * Utility function to identify users in PostHog
 * @param {string} userId - Unique identifier for the user
 * @param {object} userProperties - Additional user properties
 */
export const identifyPostHogUser = (userId, userProperties = {}) => {
    if (process.env.REACT_APP_NODE_ENV === 'Dev') return; // No posthog tracking in non-production environments
    posthog.identify(userId, userProperties);
};

/**
 * Utility function to track person properties in PostHog
 * @param {object} setProperties - Properties to set for the user
 * @param {object} setOnceProperties - Properties to set only once for the user
 * @returns
 */
export const trackPersonProperties = (setProperties, setOnceProperties) => {
    if (process.env.REACT_APP_NODE_ENV === 'Dev') return; // No posthog tracking in non-production environments
    posthog.setPersonProperties(setProperties, setOnceProperties);
};

/**
 * Utility function to register a property for all subsequent events in PostHog
 * @param {string} propertyName - Name of the property to register
 * @param {any} propertyValue - Value of the property to register
 */
export const registerPostHogProperty = (propertyName, propertyValue) => {
    if (process.env.REACT_APP_NODE_ENV === 'Dev') return; // No posthog tracking in non-production environments
    posthog.register({ [propertyName]: propertyValue });
    posthog.reloadFeatureFlags();
};
